import { array, boolean, nullable, number, object, string } from "superstruct";

import AnswerSchema from "./AnswerSchema";
import CustomerSchema from "./CustomerSchema";

const QuestionSchema = object({
    id: number(),
    customer: nullable(CustomerSchema),
    productId: number(),
    body: string(),
    createdAt: string(),
    answersCount: number(),
    answers: array(AnswerSchema),
    isPublished: boolean(),
});

export default QuestionSchema;
